import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Modal from 'react-modal';
import Stepper from 'react-stepper-horizontal';
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import Input from 'react-toolbox/lib/input';// to use input from react-toolbox library
import { actSuggestions } from 'constants/DropdownsValues';
import Button from 'react-toolbox/lib/button';
import Subheader from 'material-ui/Subheader';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Autocomplete from 'react-toolbox/lib/autocomplete';
import moment from 'moment';

import styles from './AddPosting.scss';
import { getUpdatedPostingData } from '../../common/utils/helpers';
// to import local scss fle


const inlineStyles = {
  menuStyle: {
    borderBottom: 'none',
  },
  iconStyle: {
    height: '40px',
    width: '40px',
  },
  underlineStyle: {
    borderBottom: 'none',
  },
  tileContainer: {
    fontWeight: '500',
    height: '39px',
    paddingLeft: '5px',
    fontFamily: 'unset',
    fontSize: '14px',
    border: '0.5px solid rgba(153,153,153,0.7)',
  },
};

const t40Suggestions = { };
const gpaSuggestions = {};
const satSuggestions = {};

class AddPosting extends Component {
  static propTypes = {
    addPostings: PropTypes.func,
    attributes: PropTypes.shape(),
    user: PropTypes.shape(),
    profile: PropTypes.shape(),
    createAllPostingForThisCollege: PropTypes.func,
  };

  static defaultProps = {
    addPostings: () => {},
    attributes: {},
    user: {},
    profile: {},
    createAllPostingForThisCollege: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      postingTitle: '',
      postingTitleErrorMessage: '',
      description: '',
      descriptionErrorMessage: '',
      t40: '',
      t40ErrorMessage: '',
      bench: '',
      benchErrorMessage: '',
      feetErrorMessage: '',
      endDate: '',
      endDateErrorMessage: '',
      heightInInches: '',
      heightInFeet: '',
      heightInchesErrorMessage: '',
      heightInFeetErrorMessage: '',
      weightErrorMessage: '',
      squats: '',
      squatsErrorMessage: '',
      act: '',
      actErrorMessage: '',
      gpa: '',
      gpaErrorMessage: '',
      sat: '',
      satErrorMessage: '',
      startDate: moment(),
      postingStatus: 'active',
      currentStep: 0,
      height: '',
      weight: '',
      steps: [{
        onClick: (e) => {
          this.setState({
            firstInfo: true,
            currentStep: 0,
          });
          e.preventDefault();
        } },
      {
        onClick: (e) => {
          this.setState({
            secondInfo: true,
            firstInfo: false,
            currentStep: 1,
          });
          e.preventDefault();
        } },
      ],
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePostings = this.handlePostings.bind(this);
    this.removeErrorMessage = this.removeErrorMessage.bind(this);
    this.next = this.next.bind(this);
    this.handleHeight = this.handleHeight.bind(this);
    this.handleWeight = this.handleWeight.bind(this);
    // this.handlePostingChange = this.handlePostingChange.bind(this);
  }
  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  handleHeight= (name, value) => {
    if (name === 'heightInFeet') {
      if ((value.target.value <= 7 && value.target.value >= 4) || value.target.value === '') {
        this.setState({ ...this.state, [name]: value.target.value }, () => {
          this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
        });
      }
    } else if ((value.target.value < 12 && value.target.value >= 0) || value.target.value === '') {
      this.setState({ ...this.state, [name]: value.target.value }, () => {
        this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
      });
    }
  };
  handleWeight = (name, value) => {
    this.setState({ ...this.state, [name]: value.target.value });
  };

  handlePostingChange = (event, index, value) => {
    const { profile } = this.props;
    const updatedPostingData = getUpdatedPostingData('D1', value, profile.get('gpa'));
    console.log(updatedPostingData, 'object'); // eslint-disable-line
    this.setState({ ...this.state, postingTitle: value, ...updatedPostingData });
  };

  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value }, () => {
    }); //eslint-disable-line
  };

  next() {
    const { postingTitle, heightInInches, heightInFeet,
            weight, t40 } = this.state;
    const updated = {};
    let validPostingTiltle;
    let validHeightInInches;
    let validHeightInFeet;
    let validWeight;
    let validT40;
    if (postingTitle !== '') {
      validPostingTiltle = true;
    } else {
      updated.postingTitleErrorMessage = 'Enter correct posting title';
    }
    if (heightInInches !== '') {
      validHeightInInches = true;
    } else {
      updated.heightInchesErrorMessage = 'Please add height in inches';
    }
    if (heightInFeet !== '') {
      validHeightInFeet = true;
    } else {
      updated.heightInFeetErrorMessage = 'Please add height in feet';
    }
    if (weight !== '') {
      validWeight = true;
    } else {
      updated.weightErrorMessage = 'Please add a valid weight.';
    }

        /* T40 validation */

    if (t40 !== '') {
      validT40 = true;
    } else {
      updated.t40ErrorMessage = 'Please add a valid 40-Yard Dash.';
    }
        /* T40 validation */
        /* squats validation */
    if (validHeightInFeet && validHeightInInches && validPostingTiltle
            && validT40 && validWeight) {
      this.setState({ currentStep: 1 });
    } else {
      this.setState(updated);
    }
  }

  removeErrorMessage = (name) => {
    this.setState({ ...this.state, [name]: '', squatsSuggestions: {}, benchSuggestions: {}, actSuggestions: {},
    });
  };

  handlePostings() {
    let payload = {};

    const updated = {};
    const { profile } = this.props;
    const { postingTitle, description, t40,
          postingStatus, height, weight, gpa } = this.state;

      /* Gpa validation */
    let validGpa = false;
    if (gpa !== '') {
      validGpa = true;
    } else {
      updated.gpaErrorMessage = 'Gpa is not valid.';
    }
      /* Gpa validation */

    if (validGpa) {
      const id = this.props.attributes.get('profile');
      const requirements = {
        min_gpa: gpa,
        min_t40: t40,
        min_height: height,
        min_weight: weight,
      };
      if (this.state.sat !== '') {
        requirements['min_sat'] =  this.state.sat; // eslint-disable-line
      }
      if (this.state.act !== '') {
          requirements['min_act'] =  this.state.act; // eslint-disable-line
      }
      payload = Object.assign(payload, {
        coach_id: id,
        posting_title: postingTitle,
        posting_sport: 'sport',
        team_name: 'teamName',
        coach_name: this.props.user.username,
        college_name: profile.get('college'),
        college_id: profile.get('college_id'),
        college_image: 'asdfjklasdfkj',
        city: profile.get('city'),
        state: profile.get('state'),
        team_page_link: profile.get('team_page_link'),
        question_link: profile.get('question_link'),
        division: profile.get('division'),
        posting_status: postingStatus,
        interested_profiles_list: [],
        requirements,
      });

      if (description !== '') {
        payload['description'] = description; // eslint-disable-line
      } else {
          payload['description'] = null; // eslint-disable-line
      }
      this.props.addPostings(payload);
      this.setState({
        open: false,
        postingTitle: '',
        description: '',
        t40: '',
        currentStep: 0,
        heightInFeet: '',
        heightInInches: '',
        squats: '',
        gpa: '',
        sat: '',
        act: '',
        startDate: moment(),
        bench: '',
        weight: '',
      });
    } else {
      this.setState(updated);
    }
  }

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '0px',
        maxWidth: '70%',
        transform: 'translate(-50%, -50%)',
      },
    };
      for(let i = 6;i<=16;i++){ //eslint-disable-line
          for(let x = 1;x<=10;x++) { //eslint-disable-line
            let listItem = '';
            listItem = ((i * 100) + (x * 10));
            if (listItem === 600) { listItem = '600 or Lower'; }
            satSuggestions[`${listItem}`] = `${listItem}`;
          }
      }
      for (let i = 16; i <= 36; i++) { //eslint-disable-line
        let listItem = '';
        if (i === 16) {
          listItem = `${`${i} or Lower`}`;
        } else {
          listItem = `${i}`;
        }

        actSuggestions[`${listItem}`] = `${listItem}`;
      }
      for(let i = 2;i<4;i++){ //eslint-disable-line
          for(let x = 0;x<=10;x++) { //eslint-disable-line
            let listItem = '';
              listItem = `${i + "." + x}`; // eslint-disable-line
            if (x === 10) {
                  listItem = `${i+1}.0`; // eslint-disable-line
            }
            if (listItem === '2.0') { listItem = '2.0 or Lower'; } else if (listItem === '4.0') { listItem = '4.0 or Higher'; }
            gpaSuggestions[`${listItem}`] = `${listItem}`;
          }
      }
      for(let i = 4;i<6;i++){ //eslint-disable-line
          for(let x = 0;x<=10;x++) { //eslint-disable-line
            let listItem = '';
              listItem = `${i + "." + x}`; // eslint-disable-line
            if (x === 10) {
                  listItem = `${i+1}.0`; // eslint-disable-line
            }
            if (listItem >= '4.3' && listItem <= '5.5') {
              if (listItem === '4.3') {
                listItem = '4.3 or Lower';
              } else if (listItem === '5.5') {
                listItem = '5.5 or Higher';
              }
              t40Suggestions[`${listItem}`] = `${listItem}`;
            }
          }
      }
    const { heightInchesErrorMessage, postingTitleErrorMessage,
          weightErrorMessage, satErrorMessage, actErrorMessage, gpaErrorMessage,
          t40ErrorMessage,
          heightInFeetErrorMessage, open } = this.state;
    const { createAllPostingForThisCollege, profile, user, attributes } = this.props;
    return (
      <div className={cn('row', styles.container)}>
        <div className={cn('col s12', styles.buttonPostingContainer)}>
          <button
            onClick={() => createAllPostingForThisCollege(profile, user, attributes)}
            className={styles.addNewPosting}
          >
            Create all postings
          </button>
          <button onClick={this.onOpenModal} className={styles.addNewPosting}>
            Add new posting
          </button>
        </div>
        <Modal style={modalStyle} isOpen={open} onRequestClose={this.onCloseModal} >
          <div className={cn('row')}>
            {/* eslint-disable */}
            <div className={styles.absoluteCross} onClick={this.onCloseModal}>
              x
            </div>
              {/*eslint-enable*/}
            <div className={cn('col s12', styles.header)}>
              <span>Add New Posting!</span>
            </div>
            <div className={cn('col s12', styles.fullWidth)}>
              <div className={styles.stepperContainer}>
                <Stepper
                  steps={this.state.steps}
                  activeColor={'#333'}
                  circleFontColor={'#FFF'}
                  defaultTitleColor={'#EBEBEB'}
                  activeTitleColor={'#FFF'}
                  completeColor={'#EBEBEB'}
                  activeStep={this.state.currentStep}
                />
              </div>
            </div>
            <div className={this.state.currentStep === 0 ? cn('col s12', styles.fullWidth) : styles.hidden}>
              <div className={postingTitleErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanonError)}>
                <span>POSITION I AM RECRUITING</span>
                <SelectField
                  style={inlineStyles.tileContainer}
                  value={this.state.postingTitle}
                  onChange={this.handlePostingChange}
                  menuStyle={inlineStyles.menuStyle}
                  iconStyle={inlineStyles.iconStyle}
                  underlineStyle={inlineStyles.underlineStyle}
                  autoWidth={false}
                  maxHeight={300}
                >
                  <Subheader>OFFENSIVE POSITIONS</Subheader>
                  <MenuItem value={'QBDT'} primaryText="Quarterback - Duel Threat" />
                  <MenuItem value={'QBPS'} primaryText="Quarterback - Pro Style" />
                  <MenuItem value={'WR'} primaryText="Wide Receiver" />
                  <MenuItem value={'SR'} primaryText="Slot Receiver" />
                  <MenuItem value={'RB'} primaryText="Running Back" />
                  <MenuItem value={'FB'} primaryText="Full Back" />
                  <MenuItem value={'HB'} primaryText="H-Back" />
                  <MenuItem value={'TE'} primaryText="Tight End" />
                  <MenuItem value={'OG'} primaryText="Offensive Guard" />
                  <MenuItem value={'OT'} primaryText="Offensive Tackle" />
                  <MenuItem value={'C'} primaryText="Center" />
                  <Subheader>DEFENSIVE POSITIONS</Subheader>
                  <MenuItem value={'DT'} primaryText="Defensive Tackle" />
                  <MenuItem value={'DE'} primaryText="Defensive End" />
                  <MenuItem value={'ML'} primaryText="Middle Linebacker" />
                  <MenuItem value={'OL'} primaryText="Outside Linebacker" />
                  <MenuItem value={'DB'} primaryText="Cornerback" />
                  <MenuItem value={'SS'} primaryText="Strong Safety" />
                  <MenuItem value={'FS'} primaryText="Free Safety" />
                  <Subheader>SPECIAL TEAM POSITIONS</Subheader>
                  <MenuItem value={'K'} primaryText="Kicker" />
                  <MenuItem value={'P'} primaryText="Punter" />
                  <MenuItem value={'LS'} primaryText="Long Snapper" />
                </SelectField>
              </div>
              <div className={cn('col s12', styles.heightAndWidthContainer)}>
                <div className={cn('col s12 m6', styles.heightWidth)}>
                  <span>MINIMUM HEIGHT</span>
                  <div className={cn('col s12', styles.heightContainer)}>
                    <div className={cn('col s6', styles.feetContainer)}>
                      <input
                        className={heightInFeetErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                        type="text"
                        placeholder="Feet"
                        value={this.state.heightInFeet}
                        onFocus={() => this.removeErrorMessage('heightInFeetErrorMessage')}
                        onChange={val => this.handleHeight('heightInFeet', val)}
                      />
                      <Error message={heightInFeetErrorMessage} />
                    </div>
                    <div className={cn('col s6', styles.inchesContainer)}>
                      <input
                        className={heightInchesErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                        type="text"
                        placeholder="Inches"
                        value={this.state.heightInInches}
                        onFocus={() => this.removeErrorMessage('heightInchesErrorMessage')}
                        onChange={val => this.handleHeight('heightInInches', val)}
                      />
                      <Error message={heightInchesErrorMessage} />
                    </div>
                  </div>
                </div>
                <div className={weightErrorMessage === '' ? cn('col s12 m6', styles.weightSection) : cn('col s16 m6', styles.weightSectionOnError)}>
                  <span>MINIMUM WEIGHT</span>
                  <div className={cn('col s12', styles.removePaddingWeight)}>
                    <input
                      className={styles.simpleInput}
                      value={this.state.weight}
                      onChange={val => this.handleWeight('weight', val)}
                      onFocus={() => this.removeErrorMessage('weightErrorMessage')}
                      placeholder="Pounds"
                    />
                    <Error message={this.state.weightErrorMessage} />
                  </div>
                </div>
                <div className={cn('col s12', styles.dropdowns)}>
                  <div className={t40ErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanonError)}>
                    <span>SLOWEST 40-YARD DASH</span>
                    <Autocomplete
                      source={t40Suggestions}
                      selectedPosition="below"
                      direction="down"
                      value={this.state.t40}
                      multiple={false}
                      onFocus={() => this.removeErrorMessage('t40ErrorMessage')}
                      onChange={val => this.handleChange('t40', val)}
                      onQueryChange={val => this.handleChange('t40', val)}
                    />
                    <Error message={t40ErrorMessage} />
                  </div>
                </div>
              </div>
              <div />
              <div className={cn('col s12', styles.buttonContainer)}>
                <Button onClick={this.next} label="NEXT" />
              </div>
            </div>
            <div className={this.state.currentStep === 1 ? cn('col s12', styles.fullWidth) : styles.hidden}>
              <div className={cn('col s12', styles.dropdowns)}>
                <div className={gpaErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanonError)}>
                  <span>MINIMUM GPA</span>
                  <Autocomplete
                    source={gpaSuggestions}
                    selectedPosition="below"
                    direction="down"
                    allowCreate
                    value={this.state.gpa}
                    multiple={false}
                    onChange={val => this.handleChange('gpa', val)}
                    onFocus={() => this.removeErrorMessage('gpaErrorMessage')}
                  />
                  <Error message={gpaErrorMessage} />
                </div>
                <div className={satErrorMessage === '' ? cn('col s12 m6', styles.rightSection) : cn('col s12 m6', styles.rightSectionOnError)}>
                  <span>MINIMUM SAT
                    <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                  </span>
                  <Autocomplete
                    source={satSuggestions}
                    selectedPosition="below"
                    direction="down"
                    value={this.state.sat}
                    multiple={false}
                    onChange={val => this.handleChange('sat', val)}
                    onFocus={() => this.removeErrorMessage('satErrorMessage')}
                  />
                  <Error message={satErrorMessage} />
                </div>
                <div className={actErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanonError)}>
                  <span>MINIMUM ACT
                    <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                  </span>
                  <Autocomplete
                    source={actSuggestions}
                    selectedPosition="below"
                    direction="down"
                    value={this.state.act}
                    multiple={false}
                    onChange={val => this.handleChange('act', val)}
                    onFocus={() => this.removeErrorMessage('actErrorMessage')}
                  />
                  <Error message={actErrorMessage} />
                </div>
                <div className={cn('col s12', styles.halfWidthWithSpan)}>
                  <span>DESCRIPTION
                    <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                  </span>
                  <Input
                    type="text"
                    name="full_name"
                    value={this.state.description}
                    onChange={val => this.handleChange('description', val)}
                    multiline
                  />
                </div>
                <div className={cn('col s12', styles.buttonContainer)}>
                  <Button onClick={this.handlePostings} label="POST" />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default AddPosting;



// WEBPACK FOOTER //
// ./src/components/AddPosting/AddPosting.js